import {share} from "./share";
import {summed_diffs,just_diffs} from "./dist";
import {diff_from_mean, take_mean} from "./mean";
import {normalized_typical, typical_with_scores} from "./top5";
import {apply, compose as C, concat, converge, curry, defaultTo, fromPairs, 
    filter as f, groupBy, head, identity, ifElse, includes, isNil, juxt, last, 
    map as m, mean, mergeDeepWith, not, of, prop as p, propEq, reduce, reject, 
    split, test, __, keys, omit,difference,length,
    tap
} from 'ramda';
import {r} from "./math"

const fns = {just_diffs,identity,take_mean,share,typical_with_scores,
    summed_diffs,diff_from_mean,normalized_typical}
const propAmong = curry((key,arr) => C(includes(__,arr),p(key)));
const take_children = C(propAmong("parent"),m(p("id")),f(propEq("fn", "avg")));
const take_fn = (fn_map,fn_key) => C(
    defaultTo(identity),
    p(__,reject(
        isNil,
        m(C(
            ifElse(test(/,/),
                C(converge(apply,[C(p(__,fns),head),C(of,last)]),split(",")),
                p(__,fns)),
            p(fn_key)),
            fn_map))),
    p("fn"));
const means_of = differences => C(
    m(C(r(2),mean)),
    reduce(mergeDeepWith(concat),{}),
    m(C(m(of),p(__,differences),p("id"))))

export const take_args = (data,country,sel) => {
    return C(
    concat([sel,country]),
    of,
    C(defaultTo({}),p(__,data),p("id")));
}
export const calculate = (data,country,sel,fn_map,fn_key) => 
    converge(apply,[
        take_fn(fn_map,fn_key),
        C(take_args(data,country,sel))]);
export const calculate_differences = (selected,country,data,conf,fn_map,response_rates) => {
    const no_responses = m(C(keys,f(x => !x)))(response_rates)
    const existing_data = C(
        keys,
        f(x => 
            x !== false && 
            x.filter(a => a !== false).length === x.length)
    )(data);

    const differences = C(
        fromPairs,
        m(C(
            ([key,values]) => [key,omit(no_responses[key],values)],
            juxt([p("id"),calculate(data,country,selected,fn_map,"diff")]),
        )),
        f(C(not,propAmong("fn",["","avg"]))),
        f(C(includes(__,existing_data),p("id")))
    )(conf);
    
    const possible_averages = difference(
            existing_data,
            keys(f(x => !keys(x).length,differences)))

    const averages = C(
        m(means_of(f(x => keys(x).length,differences))),
        groupBy(p("parent")),
        converge(f,[take_children,identity]),
        f(C(not,length,difference(__,possible_averages),p("children"))),
    )(conf)
  
    return {...differences,...averages} 
}